var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.875 20.4737C28.7188 20.4737 29.5625 23.8421 29.5625 23.8421C30.4062 24.6842 32.0938 23.8421 32.0938 23.8421C34.2031 25.9474 28.7188 29.7368 28.7188 30.5789C28.7188 31.421 30.8281 31.8421 29.5625 33.1052C28.8478 33.8392 27.985 34.4133 27.0312 34.7895C27.0312 39 22.8125 39 21.9688 39C21.125 39 19.4375 35.6316 19.4375 34.7895C19.4375 33.9474 20.2812 33.1052 20.2812 32.2631C20.2812 31.421 18.5938 29.7368 18.5938 29.7368C18.5938 26.3684 16.0625 27.2105 13.5312 27.2105C11 27.2105 11 23.8421 11 23.8421C11 23.8421 11 17.9474 15.2188 17.1052C19.4375 16.2631 19.4375 17.9474 19.4375 17.9474C21.125 19.6316 24.5 17.9474 26.1875 17.9474C26.1875 17.9474 27.0312 12.0526 25.3438 12.8947C23.6562 13.7368 22.1459 13.0884 21.9688 11.2105",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M43 25.5C43 36.2696 34.2696 45 23.5 45C12.7304 45 4 36.2696 4 25.5C4 14.7304 12.7304 6 23.5 6",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M46 10C46 14.416 38 26 38 26C38 26 30 14.416 30 10C30 7.87827 30.8429 5.84344 32.3431 4.34315C33.8434 2.84285 35.8783 2 38 2C40.1217 2 42.1566 2.84285 43.6569 4.34315C45.1571 5.84344 46 7.87827 46 10V10Z",
  stroke: "#FFD200",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M38 13C39.6569 13 41 11.6569 41 10C41 8.34315 39.6569 7 38 7C36.3431 7 35 8.34315 35 10C35 11.6569 36.3431 13 38 13Z",
  fill: "#FFD200"
});
function SvgTracker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracker);
export default __webpack_public_path__ + "static/media/tracker.e6dde1f0.svg";
export { ForwardRef as ReactComponent };